// Attribution: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react#sign-in-users

// Dependencies
import React, { useCallback } from 'react';

// MSAL
import { useMsal } from '@azure/msal-react';
import { loginRequest } from 'configs/authConfig';

// Material
import Button from '@mui/material/Button';

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
const SignInButton = () => {
	const { instance } = useMsal();

	// SignIn button click event handler
	const handleLogin = useCallback(
		() => {
			if (!instance) return;

			// add deep linking redirect path into azure state
			const state = sessionStorage.getItem('msalState');
			if (state) {
				loginRequest.state = state;
			}

			// use redirect
			instance
				.loginRedirect(loginRequest)
				.catch((e) => {
					console.error(e);
				});
		},
		[instance]
	);

	return (
		<Button
			size="small"
			variant="outlined"
			color="primary"
			sx={{ overflow: 'hidden', textTransform: 'none' }}
			onClick={handleLogin}
		>
			Sign In
		</Button>
	);
};

export { SignInButton };
